import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";

const STATUSES = ["processing", "packed", "shipped", "delivered"];

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [selected, setSelected] = useState(null);

  const load = () => api.get("/orders").then((r) => setOrders(r.data || []));
  useEffect(() => { load(); }, []);

  const update = async (order_id, fulfillment_status) => {
    try {
      await api.put(`/orders/${order_id}/status`, { fulfillment_status });
      toast.success("Order updated");
      load();
    } catch {
      toast.error("Update failed");
    }
  };

  return (
    <div className="p-8 md:p-12" data-testid="admin-orders">
      <header className="mb-8 flex items-end justify-between">
        <div>
          <p className="text-[11px] tracking-luxury uppercase text-poche-gold">Atelier</p>
          <h1 className="font-serif text-5xl mt-2">Orders</h1>
        </div>
        <div className="text-[11px] tracking-luxury uppercase text-white/55">{orders.length} total</div>
      </header>

      <div className="bg-poche-ink border border-white/10">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-[10px] tracking-luxury uppercase text-white/45 border-b border-white/10">
              <th className="text-left p-4">Order</th>
              <th className="text-left p-4">Customer</th>
              <th className="text-left p-4">Items</th>
              <th className="text-left p-4">Total</th>
              <th className="text-left p-4">Status</th>
              <th className="text-left p-4">Action</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <tr key={o.order_id} className="border-b border-white/5 hover:bg-white/[0.02]" data-testid={`order-${o.order_id}`}>
                <td className="p-4">
                  <div className="text-[10px] tracking-luxury uppercase text-poche-gold">#{o.order_id.slice(-8).toUpperCase()}</div>
                  <div className="text-[10px] text-white/45">{new Date(o.created_at).toLocaleDateString()}</div>
                </td>
                <td className="p-4">
                  <div>{o.customer_name}</div>
                  <div className="text-[10px] text-white/45">{o.customer_email}</div>
                </td>
                <td className="p-4">{o.items.length}</td>
                <td className="p-4 font-serif text-poche-gold">${o.total.toLocaleString()}</td>
                <td className="p-4">
                  <span className="text-[10px] tracking-luxury uppercase border border-poche-gold/40 text-poche-gold px-2 py-1">{o.fulfillment_status}</span>
                </td>
                <td className="p-4">
                  <select
                    data-testid={`order-status-${o.order_id}`}
                    value={o.fulfillment_status}
                    onChange={(e) => update(o.order_id, e.target.value)}
                    className="bg-transparent border border-white/15 text-[10px] tracking-luxury uppercase px-2 py-1.5 focus:border-poche-gold focus:outline-none"
                  >
                    {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </td>
              </tr>
            ))}
            {orders.length === 0 && (
              <tr><td colSpan={6} className="p-10 text-center text-white/45 text-sm">No orders yet — checkout to create one.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
